import _get from 'lodash/get'
import _set from 'lodash/set'
import _isString from 'lodash/isString'
import { decode as decodeBase64 } from 'base-64'
import { APP_DATA_VARIABLE_NAME } from './app-data'

// let cachedHistory = null

/**
 * Use the React DOM hydrate method
 */
export const REACT_UNIVERSAL_BROWSER_HYDRATE = 'hydrate'
/**
 * Use the React DOM render method
 */
export const REACT_UNIVERSAL_BROWSER_RENDER = 'render'

/**
 * Get the appData from which is located on the window.
 * It starts as a string which is then parsed into an object
 * and the result saved back into the window.
 */
export function getAppData (_window = global) {
  let appData = _get(_window, APP_DATA_VARIABLE_NAME, {})
  // If the data is a string it needs to be parse into an object.
  if (_isString(appData)) {
    try {
      appData = JSON.parse(
        decodeURIComponent(
          escape(decodeBase64(appData)),
        ),
      )
    } catch (e) {
      appData = {}
    }
    _set(_window, APP_DATA_VARIABLE_NAME, appData)
  }
  return appData
}
